import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import Button from '@mui/material/Button';
import { Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, TextField } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { IMaskInput } from 'react-imask';
import IntegerOnly from '../../../../utils/IntegerOnly';
import { isValidEmailRecipient } from '../../../../utils/emailRecipients';
import { getAttachments } from '../../../Chat/MessagesArea/ChatWindow/MessageItem';
import AttachmentItem from '../../../Chat/MessagesArea/ChatWindow/MessageItem/attachment';
import Typography from "@mui/material/Typography"

import { replaceMCDU } from "../../../Settings/Vivre/Vivremenu/replaceMCDU"

import { reportTriggers, months } from "../"

import api from "../../../../api"
import { getSession } from "../../../../auth"

import dayjs from "dayjs"

import "dayjs/locale/pt-br"
import "./styles.css"

dayjs.locale('pt-br');

const validateTelephoneMask = (number, type) => {
  let response = []

  if (type === 'EMAIL') {
    if (!isValidEmailRecipient(number))
      response.push(<Box>Email inválido.</Box>)
    if (response.length === 0)
      return ''
    return response
  }

  if (!number) {
    response.push(<Box>Digite um número.</Box>)
    return response
  }

  const clear_number = String(IntegerOnly(number))

  if (clear_number?.length < 10)
    response.push(<Box>Números de telefone precisam ter pelo menos 10 digitos.</Box>)
  if (clear_number?.length === 11 && clear_number[2] !== '9')
    response.push(<Box>Para esse formato de telefones, é necessário que o numero após o DDD seja um 9.</Box>)

  if (response.length === 0)
    return ''
  return response
}

const telephoneMask = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={[
        {
          mask: '(00) 0000-0000',
          overwrite: true,
        }, {
          mask: '(00) 00000-0000',
          overwrite: true,
        },
      ]}
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

const CampaignSummary = (props) => {

  const [totalContacts, setTotalContacts] = useState("Nenhum contato receberá a campanha")

  const selectedQueue = props.queues.filter(item => item[1] == props.queue)[0]
  const groupNameList = props.groupkey.map(each => each.label).join(', ')
  const enterpriseNameList = props.selectedEnterprise.map(each => each.label).join(', ')
  const templateName = props.template ? props.template.components[0].text : 'Template Excluído'
  const literal = props.sendNow ? 'Enviar agora' : props.datetime.LITERAL
  const isVoiceContinuous = props.platform === 'VOICE' && props.voiceConfig?.mode === 'CONTINUOUS'
  const platformLabel = props.platform === 'VOICE' ? 'Voz' : props.platform

  let queueName = ''
  let templateText = ''
  let senderName = ''
  let attachments = []

  if (props.platform === 'WHATSAPP') {
    queueName = selectedQueue?.[0] || ""
    senderName = props.sender
    templateText = props.template ? ((props.template.components[0] &&
      props.template.components[0]?.type) === 'BODY' ?
      props.template.components[0]?.text :
      '[MIDIA] ' + props.template?.components[1]?.text) : 'TEMPLATE INVÁLIDO/REMOVIDO'
  }
  else if (props.platform === 'SMS') {
    queueName = props.state.queue ? props.state.queue.split('_').pop() : 0
    templateText = props.state.msg
    senderName = props.state.phone_name
  } else if (props.platform === 'EMAIL') {
    queueName = props.state.queue ? props.state.queue.split('_').pop() : 0
    templateText = props.state.emailMessageData.bodyTextContent
    attachments = props.state.emailMessageData.attachments
    senderName = props.state.config.find((conf => conf.id === props.state.email))?.imap_username
  } else if (props.platform === 'VOICE') {
    templateText = ''
  }

  let period = props.time
  if (period == 'once') {
    period = props.sendNow ? 'Uma vez' : 'Uma vez na data'
  }
  else {
    period = 'Periodo'
  }

  let parameterText = ''
  const deployParameters = props.mediaParameters

  if ('headerfile' in deployParameters) {
    if (typeof (deployParameters.headerfile) == 'object')
      parameterText += `Cabeçalho: ${deployParameters.headerfile.name}.\n`
    else {
      parameterText += `Cabeçalho: ${deployParameters.headerfile.split('/').pop()}.\n`
    }
  }

  let headerstring = deployParameters.headerbody
  if (!('headerfile' in deployParameters) && 'headerURL' in deployParameters)
    headerstring = deployParameters.headerURL

  headerstring ? parameterText += `Cabeçalho: ${headerstring}.                                                  \n` : null
  deployParameters.body ? parameterText += `Corpo:     ${Object.values(deployParameters.body).join(', ')}.      \n` : null
  deployParameters.buttons ? parameterText += `Botões:    ${deployParameters.buttons}.                          \n` : null

  const campaignTestSubmit = () => {
    props.setTestCampaignModal(false)
    props.onSubmit('test-activate')
  }

  const phoneValid = validateTelephoneMask(props?.testCampaignNumber, props?.platform)

  const renderMessage = () => {

    if (props.platform === "WHATSAPP" && !props.template) {
      return (
        <Box className="summary-message-template">
          <div>Template excluído, para continuar altere o template</div>
        </Box>
      )
    }

    let parsedHeader, parsedBody, parsedFooter, attachments
    
    if (props.platform === "WHATSAPP") {
      const header = props.template.components.find((component) => component.type === "HEADER")
      if (header) {
        let mediaUrl = props.mediaParameters["headerfile"] ?? props.mediaParameters["headerURL"] ?? header.example?.header_handle?.[0]
        if (mediaUrl instanceof File)
          mediaUrl = URL.createObjectURL(mediaUrl)
        switch (header.format) {
          case "IMAGE":
            parsedHeader = (
              <img src={mediaUrl} style={{ maxWidth: "100%", marginBottom: ".5rem" }}/>
            )
            break
          case "DOCUMENT":
            parsedHeader = (
              <a href={mediaUrl} target="_blank" rel="noopener noreferrer" style={{ marginBottom: ".5rem" }}>
                Documento
              </a>
            )
            break
          case "VIDEO":
            parsedHeader = (
              <video controls style={{ maxWidth: "100%", marginBottom: ".5rem" }}>
                <source src={mediaUrl} />
              </video>
            )
            break
          case "TEXT":
            parsedHeader = (
              <div style={{ marginBottom: "1rem", fontWeight: "bold" }}>{header.text}</div>
            )
          break
          default:
            break
        }
      }

      const body = props.template.components.find((component) => component.type === "BODY")
      if (body) {
        parsedBody = body["text"]
        const bodyParams = props.mediaParameters?.body
        if (bodyParams && typeof bodyParams === "object") {
          Object.entries(bodyParams).forEach(([key, value]) => {
            const placeholder = `{{${parseInt(key, 10) + 1}}}`
            parsedBody = parsedBody.replaceAll(placeholder, value)
          })
        }
      }

      const footer = props.template.components.find((component) => component.type === "FOOTER")
      if (footer)
        parsedFooter = (
          <div style={{ marginTop: "1rem", color: "gray" }}>{footer.text}</div>
        )
    }
    else if (props.platform === "SMS") 
      parsedBody = props.state.msg.replace("{{link}}", "{{url_retorno_chatbot}}")
    else if (props.platform === "EMAIL") {
      parsedBody = props.state.emailMessageData.bodyTextContent
      attachments = props.state.emailMessageData.attachments
    }

    return (
      <Box className="summary-message-template">
        {parsedHeader ?? null}
        {parsedBody &&
          <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
            {parsedBody}
          </pre>
        }
        {Array.isArray(attachments) && attachments.length > 0 &&
          <Box mt={2}>
            {attachments.map((attachment, i) => (
              <div key={i}>
                Anexo:{" "}
                <a href={attachment.acess_directory} target="_blank" rel="noopener noreferrer">
                  {attachment.filename}
                </a>
              </div>
            ))}
          </Box>
        }
        {parsedFooter ?? null}
      </Box>
    )
  }

  const getPeriodText = (period, secondary) => {
    switch (period) {
      case "Uma vez":
        return "Envio imediato"
      case "Uma vez na data":
        const dateStr = dayjs(new Date(secondary)).format("DD/MM/YYYY HH:mm");
        return `Envio único ${dateStr}`
      default:
        return secondary
    }
  }

  useEffect(() => {
    const loadTotalContacts = async () => {
      const enterpriseId = getSession().profile.enterprise.id
      const response = await api.get(`api/enterprises/${enterpriseId}/campaign/${props.campaignId}/get_total_contacts/`)
      if (response.status === 200) {
        let msg = "contato"
        if (props.contactFilter === "enterprises_contact_group") {
          msg = "empresa"
        } 
        if (response.data == 1) {
          setTotalContacts(`1 ${msg} receberá a campanha`)
          return
        }
        setTotalContacts(`${response.data} ${msg}s receberão a campanha`)
      }
    }

    console.log("Calculando total de contatos para campanha...", props.campaignId)
    
    if (props.campaignId) {
      loadTotalContacts()
    } else if (props.contactType === 'imported' && props.importedFileCount != null) {
      if (props.importedFileCount === 1) setTotalContacts("1 contato receberá a campanha")
      else setTotalContacts(`${props.importedFileCount} contatos receberão a campanha`)
    }
  }, [props.campaignId, props.contactType, props.importedFileCount])

  return (
    <>
      {props.testCampaignModal && props.platform !== 'VOICE' &&
        <Dialog open={true}>
          <DialogTitle id="customized-dialog-title">
            Testar campanha
          </DialogTitle>
          <Divider />
          <DialogContent>
            <TextField
              label={props.platform !== 'EMAIL' ? "Digite o número" : "Digite o e-mail"}
              size="small"
              value={props.testCampaignNumber}
              onChange={(e) => props.setTestCampaignNumber(e.target.value)}
              InputProps={props.platform !== 'EMAIL' ? {
                inputComponent: telephoneMask
              } : {}}
            />
          </DialogContent>
          <DialogActions>
            <LoadingButton onClick={() => props.setTestCampaignModal(false)}>
              Cancelar
            </LoadingButton>
            <Tooltip title={phoneValid}>
              <span>
                <LoadingButton
                  disabled={phoneValid}
                  onClick={() => campaignTestSubmit()}>
                  Enviar
                </LoadingButton>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      }
      <Box className="campaign-summary">
        <Box className="summary-row">
          <Box>Nome</Box>
          <Box>{props.name}</Box>
        </Box>
        <Box className="summary-row">
          <Box>Canal</Box>
          <Box>{platformLabel}</Box>
        </Box>
        {senderName
          ? <Box className="summary-row">
              <Box>Remetente</Box>
              <Box>{senderName}</Box>
            </Box>
          : null
        }
        {props.platform === 'VOICE' && props.voiceConfig
          ? <>
              <Box className="summary-row">
                <Box>Tipo</Box>
                <Box>{isVoiceContinuous ? 'Contínua' : 'Em lote'}</Box>
              </Box>
              <Box className="summary-row">
                <Box>Telefonia</Box>
                <Box>{props.voiceConfig.telephony_backend === 'EXTERNAL' ? 'Externa' : 'Interna'}</Box>
              </Box>
              <Box className="summary-row">
                <Box>Destino</Box>
                <Box>{props.voiceConfig.destination_name || props.voiceConfig.destination_mcdu}</Box>
              </Box>
              <Box className="summary-row">
                <Box>Tentativas</Box>
                <Box>{props.voiceConfig.dial_attempt}</Box>
              </Box>
              <Box className="summary-row">
                <Box>Intervalo entre tentativas</Box>
                <Box>{props.voiceConfig.retry_interval} segundos</Box>
              </Box>
              <Box className="summary-row">
                <Box>Timeout</Box>
                <Box>{props.voiceConfig.timeout} ms</Box>
              </Box>
            </>
          : null
        }
        {queueName
          ? <Box className="summary-row">
             <Box>Fila</Box>
              <Box>{queueName}</Box>
            </Box>
          : null
        }
        {props.selectedContacts && props.selectedContacts.length > 0 
          ? (
            <Box className="summary-row">
              <Box>Contatos</Box>
              <Box>{props.selectedContacts.length} contactos selecionados da base de dados Kwik.</Box>
            </Box>
          ) 
          : props.contactType === "filtered"
            ? (
              <>
                {props.contactFilter === "contact_group" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Segmentos - {groupNameList}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "contact_enterprise" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Empresas - {enterpriseNameList}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "email" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      E-mails com final {props.contactFilterValue}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "telephone" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Telefones com DDD {props.contactFilterValue}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactType === "imported" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Arquivo importado - {props.selectedFile?.name || ''}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "created_gte" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Com data de criação maior, ou igual a {dayjs(new Date(props.contactFilterValue)).format("DD/MM/YYYY")}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "created_lte" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Com data de criação menor, ou igual a {dayjs(new Date(props.contactFilterValue)).format("DD/MM/YYYY")}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "birthday" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Aniversariantes do mês de {months[props.contactFilterValue]}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
                {props.contactFilter === "enterprises_contact_group" && (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>
                      Segmentos - {groupNameList}
                      <Typography variant="subtitle2" className="total-contacts-info">{totalContacts}</Typography>
                    </Box>
                  </Box>
                )}
              </>
            )
            : (props.contactType === "imported" 
              ? (
                <Box className="summary-row">
                  <Box>Contatos</Box>
                  <Box>Importados via arquivo</Box>
                </Box>
              )
              : isVoiceContinuous
                ? (
                  <Box className="summary-row">
                    <Box>Contatos</Box>
                    <Box>Entrada contínua</Box>
                  </Box>
                )
              : null
        )}
        {!isVoiceContinuous &&
          <Box className="summary-row">
            <Box>Periodicidade</Box>
            <Box>{getPeriodText(period, literal)}</Box>
          </Box>
        }
        {props.reportTrigger && props.reportEmail &&
          <Box className="summary-row">
            <Box>Relatório</Box>
            <Box>Enviar {reportTriggers[props.reportTrigger]} para {props.reportEmail}</Box>
          </Box>
        }
        {props.platform !== 'VOICE' &&
          <Box className="summary-message">
            <Box className="summary-row">
              <Box>Mensagem</Box>
              {props.platform == "EMAIL" && <Box>Assunto: {props.state.subject}</Box>}
            </Box>
            {renderMessage()}
          </Box>
        }
      </Box>
    </>
  )
}

export default CampaignSummary
